module.exports = __webpack_public_path__ + "static/media/chevron.48bb0a65.svg";